/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeNameFilterDTO } from './AttributeNameFilterDTO';
import {
    AttributeNameFilterDTOFromJSON,
    AttributeNameFilterDTOFromJSONTyped,
    AttributeNameFilterDTOToJSON,
} from './AttributeNameFilterDTO';
import type { NextPageDTO } from './NextPageDTO';
import {
    NextPageDTOFromJSON,
    NextPageDTOFromJSONTyped,
    NextPageDTOToJSON,
} from './NextPageDTO';
import type { AttributeFilterDTO } from './AttributeFilterDTO';
import {
    AttributeFilterDTOFromJSON,
    AttributeFilterDTOFromJSONTyped,
    AttributeFilterDTOToJSON,
} from './AttributeFilterDTO';

/**
 * 
 * @export
 * @interface QueryAttributesBodyDTO
 */
export interface QueryAttributesBodyDTO {
    /**
     * Filter by attribute (match any), if null no type or property value filtering is applied
     * @type {Array<AttributeFilterDTO>}
     * @memberof QueryAttributesBodyDTO
     */
    attributeFilter?: Array<AttributeFilterDTO>;
    /**
     * 
     * @type {AttributeNameFilterDTO}
     * @memberof QueryAttributesBodyDTO
     */
    attributeNameFilter?: AttributeNameFilterDTO;
    /**
     * Filter by attribute name, if null all attributes are considered
     * @type {Array<string>}
     * @memberof QueryAttributesBodyDTO
     */
    attributeNamesFilter?: Array<string>;
    /**
     * Filter by experiment id, if null all experiments are considered
     * @type {Array<string>}
     * @memberof QueryAttributesBodyDTO
     */
    experimentIdsFilter?: Array<string>;
    /**
     * If true, include last values for float series that have only preview points
     * @type {boolean}
     * @memberof QueryAttributesBodyDTO
     */
    includeLastForPreviewSeries?: boolean;
    /**
     * 
     * @type {NextPageDTO}
     * @memberof QueryAttributesBodyDTO
     */
    nextPage?: NextPageDTO;
}

/**
 * Check if a given object implements the QueryAttributesBodyDTO interface.
 */
export function instanceOfQueryAttributesBodyDTO(value: object): value is QueryAttributesBodyDTO {
    return true;
}

export function QueryAttributesBodyDTOFromJSON(json: any): QueryAttributesBodyDTO {
    return QueryAttributesBodyDTOFromJSONTyped(json, false);
}

export function QueryAttributesBodyDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryAttributesBodyDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeFilter': json['attributeFilter'] == null ? undefined : ((json['attributeFilter'] as Array<any>).map(AttributeFilterDTOFromJSON)),
        'attributeNameFilter': json['attributeNameFilter'] == null ? undefined : AttributeNameFilterDTOFromJSON(json['attributeNameFilter']),
        'attributeNamesFilter': json['attributeNamesFilter'] == null ? undefined : json['attributeNamesFilter'],
        'experimentIdsFilter': json['experimentIdsFilter'] == null ? undefined : json['experimentIdsFilter'],
        'includeLastForPreviewSeries': json['includeLastForPreviewSeries'] == null ? undefined : json['includeLastForPreviewSeries'],
        'nextPage': json['nextPage'] == null ? undefined : NextPageDTOFromJSON(json['nextPage']),
    };
}

export function QueryAttributesBodyDTOToJSON(value?: QueryAttributesBodyDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeFilter': value['attributeFilter'] == null ? undefined : ((value['attributeFilter'] as Array<any>).map(AttributeFilterDTOToJSON)),
        'attributeNameFilter': AttributeNameFilterDTOToJSON(value['attributeNameFilter']),
        'attributeNamesFilter': value['attributeNamesFilter'],
        'experimentIdsFilter': value['experimentIdsFilter'],
        'includeLastForPreviewSeries': value['includeLastForPreviewSeries'],
        'nextPage': NextPageDTOToJSON(value['nextPage']),
    };
}

